import * as Yup from 'yup';

export const SBOMValidationSchema = Yup.object({
  component_id: Yup.string().trim().required('Compnent id is required'),
  name: Yup.string().trim().required('Name is required'),
  version: Yup.string().trim().required('Version is required'),
  // author_contacts: Yup.string().trim().required('Author contacts is required'),
  // license_terms: Yup.string().trim().required('License terms is required'),
  // sha256_hash: Yup.string().trim().required('SHA256 is required'),
  // source_url: Yup.string().trim().required('Source url is required'),
  // supplier: Yup.string().trim().required('Supplier is required'),
});
